import { appActions } from '../actions/app.actions';

export const checkValidLoginStatus = (userId, dispatch) => {
  if (!userId) {
    dispatch(appActions.openLoginModal());
    return false;
  }
  return true;
};
